import React from 'react'
import {withStyles} from 'material-ui'

import {
    LandingPage,
    LandingHero,
    LandingCover,
    LandingBody,
    LandingHeroText,
    LandingVideo,
    LandingText,
    LandingSignup,
} from './landinglib'
import SignupForm from './SignupForm'

const styles = theme => ({
    center: {
        display: 'block',
        margin: '0 auto',
    },
    last: {
        textAlign: 'center'
    }
})

export const Landing = withStyles(styles)(
    ({classes}) => (
        <LandingPage title="Carefol.io | for caregivers">
            <LandingHero>
                <LandingCover src="/img/helping-senior-with-technology_925x.jpg" dark="0.5"/>
                <LandingHeroText>
                    <h1>Know what goes on at the doctor's office</h1>
                    <p>Do you feel like you're out of the loop when it comes to your loved one's health conditions?</p>
                    <p>You'd like to help, but when you ask how things went at the doctor's appointment, all you get is "it was fine."</p>
                    <p>You know the doctor probably gave important information, but you're not sure what it was.</p>
                    <p>Carefol.io can help.</p>
                    <LandingVideo />
                </LandingHeroText>
                <LandingSignup />
            </LandingHero>
            <LandingBody>
                <LandingText>
                    <p>
                        <a href="https://www.ncbi.nlm.nih.gov/pmc/articles/PMC539473/">Studies show</a> that
                        40-80% of the information given by doctors to patients is forgotten immediately.
                    </p>
                    <p>
                        And as our loved ones get older, there's usually <strong>more</strong> information they need to remember,
                        but it's <strong>harder</strong> for them to remember it.
                    </p>
                    <p>You'd like to be in the office every time to make sure that nothing gets lost, but sometimes that's just not possible.</p>
                    <h2>
                        Wouldn't it be nice if there was a <strong>simple</strong> solution that let you review what the doctor said,
                        <strong>word for word</strong>,
                        so that <strong>nothing gets lost</strong>?
                    </h2>
                </LandingText>
                <LandingText>
                    <p>
                        Well, now there is.
                        With Carefol.io Family Edition, you get an easy to use health platform that lets your loved ones <strong>
                        record the doctor's instructions</strong>, which are then securely and automatically <strong>
                        saved</strong> to your account, where you can <strong>
                        listen to</strong>, <strong>review</strong>, and even <strong>search</strong> the recorded instructions.
                    </p>
                    <p>
                        But what if your loved one doesn't have a smartphone? <strong>
                        No problem.</strong> Your Carefol.io account includes a voicemail number that works with any phone:
                        smartphone, flip-phone, or land-line.
                        Messages sent to this number are saved just like they are from the web app, and you can search them just the same.
                    </p>
                </LandingText>
                <LandingText className={classes.last}>
                    <h2>Carefol.io Family Edition is available risk-free for 30 days, with no credit card required.</h2>
                    <p>Sign up today, and never be out of the loop again.</p>
                </LandingText>
                <LandingSignup className={classes.center}/>
            </LandingBody>
        </LandingPage>
    )
)

export default Landing


// WEBPACK FOOTER //
// ./src/components/Landing1.jsx